<!-- 答题页面容器 -->
<template>
  <div class="container">
    <Head></Head>
    <div class="Box">
      <div class="tabBox">
        <el-tabs v-model="activeName">
          <el-tab-pane label="答题" name="first">
            <div class="quseBox">
              <div class="questions">
                <div class="currhead">
                  <!-- 当前课程 -->
                  <h1 class="currh1">{{courseName}}</h1>
                  <div @click="slices" class="currfont" style="cursor: pointer;">
                    返回
                    <img alt src="@/assets/img/slices/slices.png" style="margin-left: 10px;" />
                  </div>
                </div>
                <div class="titcent">
                  <!-- 当前试题 -->
                  <img alt src="@/assets/img/icon.png" />
                  {{ExaminationInfo.examinationName}}
                </div>
                <div>
                  <div class="question_box better-scroll-bar">
                    <div
                      :id="'answer' + item.examinationItemId"
                      :key="item.examinationItemId"
                      v-for="item in initList"
                    >
                      <!-- 单选题 -->
                      <RadioTopic
                        :bankData="item"
                        :typeText="'单选题'"
                        v-if="Number(item.questionType) === 1"
                        v-on:getChildVal="getChildVal"
                      ></RadioTopic>
                      <!-- 多选题 -->
                      <CheckboxTopic
                        :bankData="item"
                        :typeText="'多选题'"
                        v-else-if="Number(item.questionType) === 2"
                        v-on:getChildVal="getChildVal"
                      ></CheckboxTopic>
                      <!-- 判断题 -->
                      <RadioTopic
                        :bankData="item"
                        :typeText="'判断题'"
                        v-else-if="Number(item.questionType) === 3"
                        v-on:getChildVal="getChildVal"
                      ></RadioTopic>
                      <!-- 简答题 -->
                      <!-- <TextTopic
                        :bankData="item"
                        :typeText="'简答题'"
                        v-else-if="Number(item.questionType) === 4"
                        v-on:getChildVal="getChildVal"
                      ></TextTopic>-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="answerSheet">
                <!-- 右边显示列表 -->
                <ProblemControler
                  :bankkeep="bankkeep"
                  :count="numCount"
                  :is_submits="is_submit"
                  :numCount="num"
                  :selectCount="selectCount"
                  :selectData="dataAll"
                  :testTime="testTime"
                  :times="useTimeSend"
                  :type="ExaminationInfo.typeId"
                  v-on:submitAnswer="submitAnswer"
                ></ProblemControler>
              </div>
            </div>
            <div class="question_page">
              <el-pagination
                :current-page.sync="page"
                :next-text="`下一页`"
                :page-size="5"
                :prev-text="`上一页`"
                :total="count"
                @current-change="handleCurrentChange"
                layout="prev, next"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Head from '@/components/pc/Head'
import ProblemControler from '@/components/pc/questionBank/ProblemControler'
import RadioTopic from '@/components/pc/questionBank/RadioTopic'
import CheckboxTopic from '@/components/pc/questionBank/CheckboxTopic'
// import TextTopic from '@/components/pc/questionBank/TextTopic'
import * as examination_API from '@/api/ExaminationAPI'
export default {
  data () {
    return {
      bankkeep: true,
      courseName: '',
      courseId: '',
      activeName: 'first',
      initList: [],
      liData: '',      //上一层传递过来的试卷对象
      page: 1,
      pagesize: 5,
      selectCount: 0,   //当前答题总数量
      dataAll: [],     //经过组织后的题目数据
      count: 0,        //总题数
      date: 100,
      isLeaval: false,
      submitData: [],
      numCount: 0,
      is_submit: true,
      testTime: 25,    //考试s时间
      timeOut: '',
      useTimeSend: 0, //实时考试用时
      num: 0,
      prePath: sessionStorage.getItem('prePath') || '',
      push_status: false,
      examinationId: '',         //题目id
      ExaminationInfo: {},
      startTime: '',           //开始答题时间
      ExaminationItemList: [],  //服务端返回的所有试题列表
      actionType: 0
    }
  },
  components: {
    ProblemControler,
    RadioTopic,
    CheckboxTopic,
    // TextTopic,
    Head
  },

  created () {

    //从课程详细页面开始答题跳转此页面
    console.log('从课程详细页面开始答题跳转此页面')
    console.log(this.$route.params)
    console.log(JSON.parse(sessionStorage.getItem('answer')))
    if (this.$route.params.data) {
      this.examinationId = this.$route.params.examinationId
      this.courseName = this.$route.params.courseName
      this.courseId = this.$route.params.courseId
      this.ExaminationInfo = this.$route.params.examination
      this.testTime = this.$route.params.testTime
      this.actionType = this.$route.params.actionType
    } else {
      this.examinationId = JSON.parse(sessionStorage.getItem('answer')).examinationId
      this.courseName = JSON.parse(sessionStorage.getItem('answer')).courseName
      this.courseId = JSON.parse(sessionStorage.getItem('answer')).courseId
      this.ExaminationInfo = JSON.parse(sessionStorage.getItem('answer')).examination
      this.testTime = JSON.parse(sessionStorage.getItem('answer')).testTime
      this.actionType = JSON.parse(sessionStorage.getItem('answer')).actionType
    }
    if (this.actionType == 2) {
      this.useTimeSend = sessionStorage.getItem('useTimeSend') || 0
      if (this.useTimeSend == 0) {
        this.useTimeSend = this.ExaminationInfo.testTime - this.ExaminationInfo.customerExaminationTestLogEntity.useTime
      }
    } else {
      this.useTimeSend = sessionStorage.getItem('useTimeSend') || this.ExaminationInfo.testTime
    }
    console.log('ggffggg', this.testTime)
    this.passTime = this.testTime
    this.examinationItemList()
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    //  这里的vm指的就是vue实例，可以用来当做this使用
    next(vm => {
      if (from.path.length > 2) {
        sessionStorage.setItem('prePath', from.path)
        vm.prePath = from.path
      }
    })
  },
  mounted () {
    window.addEventListener('setItem', e => {
      let active = ''
      if (e.key === 'active_an') {

        active = JSON.parse(sessionStorage.getItem('active_an'))
        this.page = Math.ceil(active.index / 5)
        this.initList = []
        this.initList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
        setTimeout(() => {
          if (active.active) {
            // this.goTop(active.active)
          }
        }, 200)
      } else {
        console.log(e.key, '我在输出else')
      }
    })
  },
  watch: {
    numCount (val) {
      if (val > 0) {
        this.is_submit = false
      }
    }
  },
  methods: {
    //回退
    slices () {
      //自动保存答题进度
      if (this.selectCount > 0) {
        let arr = []
        for (let i = 0; i < this.submitData.length; i++) {
          arr[i] = this.submitData[i]
          if (Number(arr[i].questionType) === 2) {
            arr[i].select = this.submitData[i].select.length > 0 ? this.submitData[i].select.toString().replace(/[,]/g, '###') : ''
          } else {
            arr[i].select = this.submitData[i].select
          }
        }
        let useTime = sessionStorage.getItem('useTimeSend')
        let data = {
          examSetting: JSON.stringify({ body: arr, lastExaminationItemId: this.lastExaminationItemId }),
          examinationId: this.examinationId,
          courseId: this.courseId,
          startTime: this.startTime,
          useTime: this.ExaminationInfo.testTime - useTime,
          type: 3,
          isCommit: 2
        }

        examination_API.submitExaminationTestLog(data).then(res => {
          if (res && Number(res.code) === 0) {
            this.$message.success('保存当前考试进度成功')
            this.$router.back()
            this.push_status = true
          } else {
            this.$message.warning('保存当前考试进度失败')
            this.$router.back()
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$router.back()
      }
    },
    //试题列表
    examinationItemList () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let data = {
        examinationId: this.examinationId,
        courseId: this.courseId

      }
      // type 1: 开始答题 2 ：继续答题  3：重新答题
      examination_API.examinationItemList(data).then(res => {
        loading.close();
        if (res && Number(res.code) === 0) {
          this.startTime = parseInt(new Date().getTime() / 1000)//开始时间，秒为单位
          this.ExaminationItemList = res.data;
          this.count = res.data.length
          // this.numTime = res.startTime + res.testTime
          let data = []
          for (let i = 0; i < this.ExaminationItemList.length; i++) {
            this.submitData[i] = {}
            this.submitData[i].examinationItemId = this.ExaminationItemList[i].examinationItemId
            this.submitData[i].questionType = this.ExaminationItemList[i].questionType
            this.submitData[i].questionAnswer = this.ExaminationItemList[i].questionAnswer
            this.submitData[i].select = ''
            // 保证继续答题获取到数据 以及选中状态
            // 上一个页面传递过来的类型，actionType 1: 开始答题 2 ：继续答题  3：重新答题
            if (Number(this.actionType) === 2) {
              let examSetting = ''
              if (this.ExaminationInfo.customerExaminationTestLogEntity) {
                examSetting = JSON.parse(this.ExaminationInfo.customerExaminationTestLogEntity.examSetting).body//数据库答题记录
              }
              if (examSetting) {

                for (let s = 0; s < examSetting.length; s++) {
                  if (this.submitData[i].examinationItemId === examSetting[s].examinationItemId) {
                    this.submitData[i].select = examSetting[s].select
                    if (examSetting[s].select.indexOf('###') > -1) {
                      res.data[i].select = examSetting[s].select.split('###')
                      this.selectCount++
                      console.log('bbc')
                      // 这个是保证测试时错误数据的清除
                    } else if (examSetting[s].select.indexOf('[') > -1) {
                      res.data[i].select = ''
                      console.log('bb')
                    } else if (examSetting[s].select) {
                      this.selectCount++
                      console.log('bbcn')
                      res.data[i].select = examSetting[s].select
                    } else {
                      res.data[i].select = ''
                    }
                  }
                }
              }
            }
            data[i] = this.ExaminationItemList[i]
            data[i].order = (i + 1)

          }
          this.dataAll = data
          console.log(this.dataAll)
          // 保证刷新后用户的数据不丢失
          if (sessionStorage.getItem('saveData')) {
            this.selectCount = 0
            this.dataAll = JSON.parse(sessionStorage.getItem('saveData'))
            for (let i = 0; i < this.dataAll.length; i++) {
              for (let s = 0; s < this.submitData.length; s++) {
                if (this.dataAll[i].examinationItemId === this.submitData[s].examinationItemId) {
                  if (this.dataAll[i].select instanceof Array) {
                    if (this.dataAll[i].select.length > 0) {
                      this.selectCount++
                      this.submitData[s].select = this.dataAll[i].select.toString.replace(',', '###')
                    } else {
                      this.submitData[s].select = ''
                    }
                  } else {
                    if (this.dataAll[i].select) {
                      this.selectCount++
                      this.submitData[s].select = this.dataAll[i].select
                    } else {
                      this.submitData[s].select = ''
                    }
                  }
                }
              }
            }
          }
          this.initList = this.dataAll.slice((this.page - 1) * this.pagesize, this.page * this.pagesize)
        } else {
          this.$message.warning(res.message)
        }
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.page = val
      this.initList = []
      this.initList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
    },
    // goTop (el) {
    //   document.querySelector(el).scrollIntoView(true)
    // },
    // 点击选项获取答案
    getChildVal (obj) {
      console.log(this.startTime)
      if (obj.examinationItemId) {
        this.lastExaminationItemId = obj.examinationItemId
        for (let i = 0; i < this.submitData.length; i++) {
          if (this.submitData[i].examinationItemId === obj.examinationItemId) {
            if (obj.select instanceof Array) {
              //如果是多选题
              if (obj.select.length > 0) {
                this.submitData[i].select = obj.select.sort().toString().replace(/[,]/g, '###')
              } else {
                this.submitData[i].select = ''
              }
            } else {
              this.submitData[i].select = obj.select
            }
            this.dataAll[i].select = obj.select
          }
        }
        sessionStorage.setItem('saveData', JSON.stringify(this.dataAll))
        let num = 0
        for (let s = 0; s < this.submitData.length; s++) {
          if (this.submitData[s].select) {
            num++
          }
        }
        this.selectCount = num
      }
    },

    //提交试卷前数据组装
    submitAnswer (status) {
      if (status) {
        let arr = []
        //  this.submitData = JSON.parse(sessionStorage.getItem('saveData'))
        for (let i = 0; i < this.submitData.length; i++) {
          arr[i] = this.submitData[i]
          if (Number(arr[i].questionType) === 2) {
            arr[i].select = this.submitData[i].select.toString().replace(/[,]/g, '###')
          } else {
            arr[i].select = this.submitData[i].select
          }
        }
        let useTime = sessionStorage.getItem('useTimeSend')
        let data = {
          examSetting: JSON.stringify({ body: arr, lastExaminationItemId: this.examinationId }),
          examinationId: this.examinationId,
          courseId: this.courseId,
          startTime: this.startTime,
          useTime: this.ExaminationInfo.testTime - useTime,
          type: 3,
          isCommit: 1,
        }
        return this.submitExaminationTestLog(data)
      }
    },

    // 提交试卷数据
    submitExaminationTestLog (data) {
      examination_API.submitExaminationTestLog(data).then(res => {
        if (res && Number(res.code) === 0) {
          let customerExaminationTestLogId = res.data
          this.ExaminationInfo.customerExaminationTestLogId = customerExaminationTestLogId;
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 1500
          });
          this.ExaminationInfo.courseId=this.courseId
          setTimeout(() => {
            this.$router.push({
              name: 'Result',
              params: this.ExaminationInfo
            })
            sessionStorage.setItem('results_page', JSON.stringify(this.ExaminationInfo))
            this.push_status = true
          }, 1800);
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },

  destroyed () {
    sessionStorage.removeItem('saveData')
    sessionStorage.removeItem('prePath')
    sessionStorage.removeItem('useTimeSend')
    var end = setInterval(function () { }, 100)
    var start = (end - 100) > 0 ? end - 100 : 0
    for (var i = start; i < end; i++) {
      clearInterval(i)
    }
  }
}

</script>
<style scoped>
.question_box {
  height: 500px;
  overflow: auto;
}
.titcent {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
}
.titcent img {
  margin-right: 16px;
}
.currhead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.currh1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.quseBox {
  display: flex;
  justify-content: space-between;
}
.questions {
  width: 844px;
  height: 780px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 40px;
}
.answerSheet {
  width: 425px;
  height: 780px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
.tabBox {
  max-width: 1282px;
  margin: 0 auto;
  margin-top: 30px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0px;
}
::v-deep .el-pagination button:disabled {
  margin-right: 10px;
}
::v-deep .el-pagination {
  margin: 20px 0;
}
</style>










